import { render, staticRenderFns } from "./CreatePermission.vue?vue&type=template&id=a94bc23e&scoped=true&"
import script from "./CreatePermission.vue?vue&type=script&lang=ts&"
export * from "./CreatePermission.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePermission.vue?vue&type=style&index=0&id=a94bc23e&prod&lang=sass&scoped=true&"
import style1 from "./CreatePermission.vue?vue&type=style&index=1&id=a94bc23e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94bc23e",
  null
  
)

export default component.exports